<template>
    <div class="download-app">
        <div class="image">
            <img width="514" height="465" :src="iphone" class="app-image" alt="Truckdown Search App"/>
        </div>
        <div class="description">
            <h2>Download our free app</h2>
            <div class="logo">
                <img :src="logo" width="60" height="60" alt="Truckdown logo"/>
            </div>
            <p>
                Take your TruckDown account with you. All the features available on the TruckDown website can be accessed
                through the free TruckDown Search App. Available on the Apple Store or Google Play.
            </p>

            <div class="apple"><a href="https://itunes.apple.com/us/app/truckdown-search/id925314748?mt=8" target="_blank"><img src="/img/prod/content/appstore.png" width="150" height="49" alt="App Store" /></a></div>
            <div class="google"><a href="https://play.google.com/store/apps/details?id=com.truckdown" target="_blank"><img src="/img/prod/content/google_play_narrow.png" width="150" height="50" alt="Google Play" /></a></div>

            <div class="gps">
                <div>
                    <h2>
                        GPS User?
                    </h2>
                    <p>
                        TruckDown provides vendor information to the majority of Truck Specific GPS devices sold each year and we provide lifetime updates through device manufacturers.
                    </p>
                </div>
                <div class="gps-image">
                    <img alt="GPS Device" width="250" height="202" src="/img/prod/content/gps.png" />
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>import script from './DownloadApp';
    export default script;</script>

<style lang="less" scoped>
    @import "./DownloadApp.less";
</style>
